import {
    GET_ALL_SKILL, SEARCH_ALL_SKILL, CHANGE_SKILL_STATUS, RESET_SKILL_PATH, GET_CUSTOM_SKILL_PATH, GET_SKILL, SEARCH_SKILL, CHECK_SKILLPATH_LENGTH, CREATE_CUSTOM_SKILLPATH, EDIT_SKILL_PATH, GET_SKILL_PATH_DETAILS, GET_CUSTOM_SKILL_PODS,
    CHANGE_SKILLPATH_STATUS, RESET_SKILL_PODS, ADD_SKILL_PODs, CHANGE_SKILLPOD_STATUS, REORDER_SKILLPOD,
    GET_SUBTOPICS, GET_SUBTOPICS_FAILED, ADD_SUBTOPIC, EDIT_SUBTOPIC, CHANGE_SUBTOPIC_STATUS, REORDER_SUBTOPIC,
    GET_SUBTOPIC_RESOURCES, GET_PREVIEW, CHANGE_RESOURCE_STATUS, NULL_PREVIEW, RESET_RESOURCES,
    ADD_RESOURCE, REORDER_RESOURCES, CHANGE_SOURCE, GET_DOCUMENTS_STATE, GET_DOCUMENTS_PERCENT, RESET_PERCENTAGE, UPDATE_RESOURCE, ADD_QUIZ_TO_POD
} from '../../actionType/type';
import { getApiCall, postApiCall, previewCall } from "../../utils/request";
import { returnErrors } from "../errorAction";
import axios from 'axios';


export const getAllSkills = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/custom/skills`);
        dispatch({ type: GET_ALL_SKILL, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getSearchSkills = (val) => async (dispatch) => {
    return dispatch({ type: SEARCH_ALL_SKILL, payload: val });
}

export const changeSkillStatus = (id, checked) => async (dispatch) => {
    const obj = {
        _id: id
    };
    try {
        const response = await postApiCall(`admin/skill/toggle`, obj);
        if (response.data.success) {
            dispatch({ type: CHANGE_SKILL_STATUS, payload: { id, checked } });
            returnErrors(dispatch, checked ? 'Skill is deactivated' : 'Skill is activated', response?.status);
        } else {
            returnErrors(dispatch, response.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status);
    }
}


export const createCustomSkill = (obj, title) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/skills`, obj);
        if (response.data.success) {
            returnErrors(dispatch, `${title} Skill has been created`, response?.status);
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
};

export const updateCustomSkill = (obj, title) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/skill/edit`, obj);
        if (response.data.success) {
            returnErrors(dispatch, `${title} Skill has been updated`, response?.status);
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
};

export const checkSkillPathLength = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/skillpath/check?_id=${id}`);
        console.log(response.data)
        return dispatch({ type: CHECK_SKILLPATH_LENGTH, payload: response.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}


export const activeSkillpath = (id, checked) => async (dispatch) => {
    const obj = {
        _id: id
    };
    try {
        const response = await postApiCall(`admin/skillpath/toggle`, obj);
        if (response.data.success) {
            dispatch({ type: CHANGE_SKILLPATH_STATUS, payload: { id, checked } });
            returnErrors(dispatch, !checked ? 'Skillpath has been activated' : 'Skillpath has been deactivated', response?.status);
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
};

export const publishSkillpath = (id, checked) => async (dispatch) => {
    const obj = {
        _id: id
    };
    try {
        const response = await postApiCall(`admin/skillpath/publish`, obj);
        if (response.data.success) {
            // dispatch({ type: PUBLISHED });
            returnErrors(dispatch, 'Skillpath has been published', response?.status);
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
};

export const resetSkillPath = (val) => async (dispatch) => {
    return dispatch({
        type: RESET_SKILL_PATH, payload: val
    });
}

export const getCustomSkillPath = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/skillpath?skill_id=${id}`);
        dispatch({ type: GET_CUSTOM_SKILL_PATH, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}


export const getSkills = (page) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/skillpath/skills`);
        dispatch({ type: GET_SKILL, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getSearchSkill = (val) => async (dispatch) => {
    return dispatch({
        type: SEARCH_SKILL, payload: val
    });
}

export const createCustomSkillpath = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/skillpath`, obj);
        dispatch({ type: CREATE_CUSTOM_SKILLPATH, payload: response.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const createOwnSkillpath = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/skillpath/create`, obj);
        dispatch({ type: CREATE_CUSTOM_SKILLPATH, payload: response.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const editSkillpath = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/skillpath/edit`, obj);
        if (response.data.success) {
            dispatch({ type: EDIT_SKILL_PATH, payload: obj.title });
            returnErrors(dispatch, 'Skillpath name updated', response?.status);
        } else {
            returnErrors(dispatch, response.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status
        );
    }
};

export const getSkillPodDetails = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/skillpath/details?_id=${id}`);
        dispatch({ type: GET_SKILL_PATH_DETAILS, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const resetSKillpods = () => async (dispatch) => {
    dispatch({ type: RESET_SKILL_PODS });
};

export const getSkillPods = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/skillpath/topics?_id=${id}`);
        dispatch({ type: GET_CUSTOM_SKILL_PODS, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const savedSkillPod = (obj) => async (dispatch) => {
    let data = new FormData();
    data.append("title", obj.name);
    data.append("image", obj.image);
    data.append("_id", obj._id);

    try {
        const response = await postApiCall(`admin/skillpath/topics`, data);
        if (response.data.success) {
            dispatch({ type: ADD_SKILL_PODs, payload: response.data.data });
            returnErrors(dispatch, 'Topic Saved successfully', response?.status);
        } else {
            returnErrors(dispatch, response.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status
        );
    }
};

export const updatedSkillPod = (obj) => async (dispatch) => {
    let data = new FormData();
    data.append("title", obj.title);
    obj.image && data.append("image", obj.image);
    data.append("topic_id", obj.topic_id);
    try {
        const response = await postApiCall(`admin/skillpath/topics/edit`, data);
        if (response.data.success) {
            returnErrors(dispatch, 'Topic updated', response?.status);
        } else {
            returnErrors(dispatch, response.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status
        );
    }
};

export const changeSkillPodStatus = (id, sId, checked) => async (dispatch) => {
    const obj = {
        topic_id: id,
        skillpath_id: sId
    };
    try {
        const response = await postApiCall(`admin/skillpath/topics/toggle`, obj);
        if (response.data.success) {
            dispatch({ type: CHANGE_SKILLPOD_STATUS, payload: { id, checked } });
            returnErrors(dispatch, checked ? 'Topic is deactivated' : 'Topic is activated', response?.status);
        } else {
            returnErrors(dispatch, response.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status);
    }
};

export const reorderSkillPods = (result) => async (dispatch) => {
    return dispatch({ type: REORDER_SKILLPOD, payload: result })
};

export const reorderedSkillPods = (_id, data) => async (dispatch) => {
    let obj = {
        _id,
        data
    }
    try {
        const response = await postApiCall(`admin/skillpath/topics/reorder`, obj);

    }
    catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status)
    }
};




//subtopics
export const getSubTopics = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/skillpath/subtopics?topic_id=${id}`);
        if (response.data.success) {
            dispatch({ type: GET_SUBTOPICS, payload: response.data.data });
        }
        else {
            dispatch({ type: GET_SUBTOPICS_FAILED, });
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status);
    }
}

export const savedSubTopic = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/skillpath/subtopics`, obj);
        dispatch({ type: ADD_SUBTOPIC, payload: response.data });
        returnErrors(dispatch, 'SubTopic added', response?.status);
    } catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status
        );
    }
};

export const editedSubTopic = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/skillpath/subtopics/edit`, obj);
        dispatch({ type: EDIT_SUBTOPIC, payload: response.data });
        returnErrors(dispatch, 'SubTopic title updated', response?.status);
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error?.response?.status
        );
    }
};

export const changeSubtopicStatus = (id, sId, tId, checked) => async (dispatch) => {
    const obj = {
        subtopic_id: id,
        topic_id: tId,
        skillpath_id: sId
    };
    try {
        const response = await postApiCall(`admin/skillpath/subtopics/toggle`, obj);
        if (response.data.success) {
            dispatch({ type: CHANGE_SUBTOPIC_STATUS, payload: { id, checked } });
            returnErrors(dispatch, checked ? 'Subtopic is deactivated' : 'Subtopic is activated', response?.status);
        } else {
            returnErrors(dispatch, response.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status);
    }
};

export const reorderSubTopics = (result) => async (dispatch) => {
    return dispatch({ type: REORDER_SUBTOPIC, payload: result })
};

export const reorderedSubTopics = (topic_id, data) => async (dispatch) => {
    let obj = {
        topic_id,
        data
    }
    try {
        const response = await postApiCall(`admin/skillpath/subtopics/reorder`, obj);

    }
    catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status)
    }
};




//subtopic resources

export const resetResourceLoading = () => async (dispatch) => {
    dispatch({ type: RESET_RESOURCES });
};

export const getSubtopicResources = (topicId, subtopic) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/skillpath/resource?topic_id=${topicId}&subtopic=${encodeURIComponent(subtopic)}`);
        dispatch({ type: GET_SUBTOPIC_RESOURCES, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status)
    }
};

export const changeResourceStatus = (type, id, sId, topicId, subId, checked) => async (dispatch) => {
    let obj = {
        type,
        r_id: id,
        skillpath_id: sId,
        topic_id: topicId,
        subtopic_id: subId,
        active: !checked
    }
    try {
        const response = await postApiCall(`admin/skillpath/resource/toggle`, obj);
        if (response.data.success) {
            dispatch({ type: CHANGE_RESOURCE_STATUS, payload: { id, checked } });
            returnErrors(dispatch, checked ? 'Resource is deactivated' : 'Resource is activated', response?.status);
        } else {
            returnErrors(dispatch, response.data?.message, response?.status)
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status);
    }
}

export const reorderSubTopicsResources = (result) => async (dispatch) => {
    return dispatch({ type: REORDER_RESOURCES, payload: result })
};

export const reorderdSubTopicsResources = (topicid, subtopic, sortArr) => async (dispatch) => {
    let obj = {
        topic_id: topicid,
        subtopic: subtopic,
        data: sortArr
    }
    try {
        const response = await postApiCall(`admin/skillpath/resource/reorder`, obj);

    }
    catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status)
    }
};

export const googleLinkPreview = (obj) => async (dispatch) => {
    try {
        const response = await previewCall(`https://api.linkpreview.net/?key=755c4cda9aa242c315c3f6a9fe257471&fields=site_name&q=${obj}`);
        if (response.data) {
            dispatch({ type: GET_PREVIEW, payload: response.data });
        } else {
            returnErrors(dispatch, response.data?.description, response?.status)
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data?.description, error.response?.status)
    }
}

export const googleLinkPreviewSetNull = (data) => async (dispatch) => {
    dispatch({ type: NULL_PREVIEW, payload: "" });
};

export const addLink = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/skillpath/resource/add-link`, obj);
        if (response.data.success) {
            dispatch({ type: ADD_RESOURCE, payload: response.data.data });
            returnErrors(dispatch, 'Resource added', response?.status);
        }
        else {
            returnErrors(dispatch, response.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status);
    }
};

export const updateContent = (obj) => async (dispatch) => {
    if (obj.get('type') === 'Article') {
        try {
            const response = await postApiCall(`admin/skillpath/resource/edit`, obj);
            if (response.data.success) {
                dispatch({ type: UPDATE_RESOURCE, payload: response.data.data });
                returnErrors(
                    dispatch, 'Resource updated', response.status
                );
            } else {
                returnErrors(dispatch, response.data?.message, response?.status);
            }
        } catch (error) {
            returnErrors(
                dispatch, error.response?.data?.message, error.response?.status
            );
        }
    }
    else {
        dispatch({ type: GET_DOCUMENTS_STATE, payload: true });
        const AuthStr = "Bearer " + localStorage.getItem("loginToken");
        try {
            let percent = 0;
            const config = {
                headers: { Authorization: AuthStr },
                onUploadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent
                    percent = Math.round((loaded * 100) / total);
                    if (percent < 98) {
                        return dispatch({ type: GET_DOCUMENTS_PERCENT, payload: percent })
                    }
                    else {
                        return dispatch({ type: GET_DOCUMENTS_PERCENT, payload: 98 })
                    }
                }
            }
            await axios.post(process.env.REACT_APP_API_KEY + 'admin/skillpath/resource/edit', obj, config)
                .then((response) => {
                    if (response.data.success) {
                        dispatch({ type: GET_DOCUMENTS_PERCENT, payload: 100 })
                        dispatch({ type: GET_DOCUMENTS_STATE, payload: false });
                        dispatch({ type: UPDATE_RESOURCE, payload: response.data.data });
                    } else {
                        dispatch({ type: GET_DOCUMENTS_STATE, payload: false });
                        returnErrors(dispatch, response.data?.message, response?.status);
                    }
                });
        }
        catch (error) {
            dispatch({ type: GET_DOCUMENTS_STATE, payload: false });
            returnErrors(
                dispatch, error.response?.data?.message, error.response?.status
            );
        }
    }
};



export const resetPercentage = () => async (dispatch) => {
    dispatch({
        type: RESET_PERCENTAGE
    })
}

export const handleChangeSource = (val) => async (dispatch) => {
    return dispatch({ type: CHANGE_SOURCE, payload: val })
};

//Upload document
export const uploadDocument = (obj) => async (dispatch) => {
    const AuthStr = "Bearer " + localStorage.getItem("loginToken");
    dispatch({ type: GET_DOCUMENTS_STATE, payload: true });
    try {
        let percent = 0;
        const config = {
            headers: { Authorization: AuthStr },
            onUploadProgress: (progressEvent) => {
                const { loaded, total } = progressEvent
                percent = Math.round((loaded * 100) / total);
                if (percent < 98) {
                    return dispatch({ type: GET_DOCUMENTS_PERCENT, payload: percent })
                }
                else {
                    return dispatch({ type: GET_DOCUMENTS_PERCENT, payload: 98 })
                }
            }
        }
        await axios.post(process.env.REACT_APP_API_KEY + 'admin/skillpath/resource/upload/document', obj, config)
            .then((response) => {
                if (response.data.success) {
                    dispatch({ type: GET_DOCUMENTS_PERCENT, payload: 100 })
                    dispatch({ type: GET_DOCUMENTS_STATE, payload: false });
                    dispatch({ type: ADD_RESOURCE, payload: response.data.data });
                    returnErrors(dispatch, 'Resource added', response?.status);
                } else {
                    dispatch({ type: GET_DOCUMENTS_STATE, payload: false });
                    returnErrors(dispatch, response.data?.message, response?.status);
                }
            });
    }
    catch (error) {
        dispatch({ type: GET_DOCUMENTS_STATE, payload: false });
        returnErrors(dispatch, error.response.data?.message, error.response?.status)
    }

};


//Upload video
export const uploadVideo = (obj) => async (dispatch) => {
    const AuthStr = "Bearer " + localStorage.getItem("loginToken");
    dispatch({ type: GET_DOCUMENTS_STATE, payload: true });
    try {
        let percent = 0;
        const config = {
            headers: { Authorization: AuthStr },
            onUploadProgress: (progressEvent) => {
                const { loaded, total } = progressEvent
                percent = Math.round((loaded * 100) / total);
                if (percent < 98) {
                    return dispatch({ type: GET_DOCUMENTS_PERCENT, payload: percent })
                }
                else {
                    return dispatch({ type: GET_DOCUMENTS_PERCENT, payload: 98 })
                }
            }
        }
        await axios.post(process.env.REACT_APP_API_KEY + 'admin/skillpath/resource/upload/video', obj, config)
            .then((response) => {
                if (response.data.success) {
                    dispatch({ type: GET_DOCUMENTS_PERCENT, payload: 100 })
                    dispatch({ type: GET_DOCUMENTS_STATE, payload: false });
                    dispatch({ type: ADD_RESOURCE, payload: response.data.data });
                    returnErrors(dispatch, 'Resource added', response?.status);
                } else {
                    dispatch({ type: GET_DOCUMENTS_STATE, payload: false });
                    returnErrors(dispatch, response.data?.message, response?.status);
                }
            });
    }
    catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status)
    }
};

export const addQuizToPod = (obj) => async (dispatch) => {

    try {
        const response = await postApiCall(`admin/custom/quiz/add-to-pod`, obj);
        if (response.data.success) {
            dispatch({ type: ADD_QUIZ_TO_POD });
            returnErrors(dispatch, `Quiz added to ${obj.subtopic}`, response?.status);
        } else {
            returnErrors(dispatch, response.data?.message, response?.status)
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data?.message, error.response?.status);
    }
}





